import { Size } from '../../../styles/theme.mjs';
import styled from 'styled-components';

const StyledLink = styled.a `
  all: unset;
  display: flex;
  gap: 8px;
  cursor: pointer;
  color: ${props => (props.color ? props.color : props.theme.colors.textColor)};
  font-size: ${props => { var _a; return (_a = props.theme.typography.interactive[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.fontSize; }};
  font-weight: ${props => { var _a; return (_a = props.theme.typography.interactive[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.fontWeight; }};

  @media (pointer: fine) {
    &:hover {
      color: ${props => (props.hoverColor ? props.hoverColor : props.theme.colors.textColor)};
    }
  }
`;

export { StyledLink as default };
//# sourceMappingURL=Link.mjs.map
